import BasePage from '../../../../../components/table_page';

export default {
  name: 'banquet_product_circulation_record',
  extends: BasePage,
  data() {
    return {};
  },
  components: {},
  created() {
    this.getConfigList('main_list');
  },
  methods: {},
};
